import React from 'react';
import { Modal } from 'antd';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import OWButton from '../ow_button/OWButton';
import EntityAddRequestDetails from './EntityAddRequestDetails';

// Read-only detail view for a request (used by the "View" action, e.g. on approved requests).
function ViewEntityAddRequestModal({ visible, record, hideModal }) {
	return (
		<Modal
			visible={visible}
			width={600}
			title={`Review Request: ${nullSafeGetOrElse('displayName', record, '')}`}
			onCancel={hideModal}
			closable={true}
			destroyOnClose={true}
			footer={[
				<OWButton key="done" type="primary" size="large" onClick={hideModal}>
					Done
				</OWButton>,
			]}
		>
			<EntityAddRequestDetails record={record} />
		</Modal>
	);
}

export default ViewEntityAddRequestModal;
